import React, {useContext} from "react"
import {RelatedContext} from "../../Context/RelatedContext"
import RelatedComponent from "./RelatedComponent"
export default function SingleRelatedComponent() {
  const {Related} = useContext(RelatedContext)
  return <RelatedComponent relatedId={2}  style={{ height: "min-content" }} />
}
